import React from "react";
import { LinkContainer } from "react-router-bootstrap";
import "./Header.css";

export default function Header(props: { title: string }) {
  return (
    <div className="HeaderContainer">
      <div className="HeaderTitle">{props.title}</div>
      <div className="HeaderSpacer" />
      <LinkContainer to="/">
        <div className="HeaderX">✖️</div>
      </LinkContainer>
    </div>
  );
}
